import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Inline error state with retry button.
 * Use inside any component where data fetching can fail.
 * 
 * Props:
 *   onRetry - callback for the retry button
 *   message - optional custom message (overrides default)
 */
export default function InlineError({ onRetry, message }) {
  const { t } = useTranslation();

  return (
    <div
      className="inline-error-state"
      data-testid="inline-error"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem 1rem',
        gap: '12px',
        textAlign: 'center',
        minHeight: '120px',
      }}
    >
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      <p style={{ margin: 0, color: '#64748b', fontSize: '14px', lineHeight: 1.5 }}>
        {message || t('network.loadError')}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          data-testid="retry-button"
          style={{
            padding: '8px 24px',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            background: '#fff',
            color: '#334155',
            fontSize: '13px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'background 0.15s',
          }}
          onMouseOver={(e) => e.currentTarget.style.background = '#f8fafc'}
          onMouseOut={(e) => e.currentTarget.style.background = '#fff'}
        >
          {t('network.retry')}
        </button>
      )}
    </div>
  );
}
